module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/TANK.1198dd70.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/TANK.png
// module id = 1306
// module chunks = 16